'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FileUpload = require('./FileUpload');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FileUpload).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=DropFileUpload.js.map